export function validateCnpjCpf(value: string) {
    value = value.replace(/\D/g, '')
    if (value.length === 11 || value.length === 14) return true
    return false
}